import MainLayout from "@/components/layout/admin/MainLayout.vue";
import {
    required,
    email
} from "vuelidate/lib/validators";
import axios from "axios";

export default {
    name: "adminApplicantUpdate",
    components: {
        MainLayout
    },

    data() {
        return {
            isEditForm: true,
            applicant: {
                name: "",
                email: "",
                phone_number: "",
                address: "",
                gender: ""
            },
            error_email:"",
            submitted: false
        };
    },

    validations: {
        applicant: {
            name: {
                required
            },
            email: {
                required,
                email
            },
            phone_number: {
                required
            },
            address: {
                required
            },
            gender: {
                required
            }
        }
    },

    methods: {
        handleSubmit() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.updateApplicant();
        },

        showApplicantUpdate() {
            axios.get("/admin/applicant/update/" + this.$route.params.id)
                .then(response => {
                    this.applicant = response.data;
                })
                .catch(error => {
                    console.log("Show Applicant Update API Error", error);
                });
        },

        updateApplicant() {
            var request = {
                id: this.applicant.id,
                name: this.applicant.name,
                email: this.applicant.email,
                phone_number: this.applicant.phone_number,
                address: this.applicant.address,
                gender: this.applicant.gender
            };
            axios.post("/admin/applicant/updated", request)
            .then(response=> {
                if (response.data.msg) {
                    this.error_email = response.data.msg;
                    this.$notification.error("Applicant Edit Failed", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                } else {
                    this.$notification.success("Applicant Edited Successfully", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    this.$router.push({
                        name: "adminApplicantList"
                    });
                }
            });
        }
    },

    created() {
        this.showApplicantUpdate();
    }
};